<button type="button" class="card" (click)="clickit.emit()">
	@if (bovenschrift()) {
		<span class="bovenschrift">{{ bovenschrift() }}</span>
	}
	<div class="inhoud">
		<div class="titel-filtering">
			<span class="titel">{{ weergaveTitel() }}</span>
			@if (filteringTekst()) {
				<span class="filtering line-clamp-2">{{ filteringTekst() }}</span>
			}
		</div>
		@if (hoofdpagina()) {
			<span class="tag">{{ hoofdpagina() }}</span>
		}
	</div>
</button>
